(function() {
    var globals = require("./globals.js");
    var utils = require("./utils.js");

    module.exports = {
	dateToX: dateToX,
	getRx: getRx,
	getOpacity: getOpacity,
	getY: getY,
	getX: getX,
	removeUnlinkedPeople: removeUnlinkedPeople,
	createTimescale: createTimescale,
    }

    function dateToX(date) {
	sections = date.split("/");
	if(sections.length > 1) {
	    xPos = (sections[0] * globals.units.daySize) + (sections[1] * globals.units.monthSize) + globals._data.datesData.filter(function(d) { return d.year == sections[2]; })[0].x;
	} else {
	    xPos = globals._data.datesData.filter(function(d) { return d.year == sections[0]; })[0].x;
	}
	return xPos;
    }
    
    function getRx(start,end,datasets) {
	if(start != '') {
	    return ((dateToX(end) - dateToX(start)) /2) + (7* datasets.length);
	} else {
	    return window.innerWidth < 1400 ? 5 * datasets.length : 7 * datasets.length;
	}
    }
    
    function getOpacity(ongoing) {
	if(ongoing == true) {
	    return 0.4
	} else {
	    return 0.5
	}
    }
    
    function getY(start, end, datasets) {
	if(datasets.length > 1) {
	    total = 0;
	    for(data in datasets) {
		total = total + globals.yAxis[datasets[data]].yVal;
	    }
	    y = total / datasets.length;
	} else {
	    y = globals.yAxis[datasets[0]].yVal;
	}
	
	if(start != '') {
	    y = y + ((dateToX(end) - dateToX(start)) / 15);
	}
	return y
    }
    
    function getX(d) {
	if(d.startDate !='') {
	    base = dateToX(d.startDate);
	    halfLen = (dateToX(d.endDate) - dateToX(d.startDate)) / 2
	    d.fx = base + halfLen
	    return base + halfLen
	    
	} else {
	    d.ongoing = false;
	    d.fx =  dateToX(d.date);
	    return dateToX(d.date);
	}	    
    };
    
    function createTimescale(eventsdata) {
        globals._data.datesData = []
        eventsdata.forEach(function(d) {
            if(d.startDate != '') {
                checkDates(d.startDate);
                checkDates(d.endDate);
            } else {
                checkDates(d.date);
            }
        })
        globals._data.datesData = globals._data.datesData.sort(function(a, b) { return a.year - b.year; });
        assignDateVals()
//	globals._data.datesData = datesData;
    }

    function assignDateVals() {

        prevDate = globals._data.datesData[0].year;
        i = 0;
        for(d in globals._data.datesData) {
            globals._data.datesData[d].x = globals.units.leftMargin + (i * globals.units.yearSize);
            if((globals._data.datesData[d].year - prevDate) > 1) {
                globals._data.datesData[d].timebreak = true;
            }
            i = i +1;
            prevDate = globals._data.datesData[d].year;
        }
    }
    
    function checkDates(date) {
	year = utils.formatDate(date) 
	if(utils.checkExists(year, globals._data.datesData, 'year') == false) {
	    globals._data.datesData.push({ year:year, x:0, timebreak:false})
	}
    }
    
    function removeUnlinkedPeople(nodes, links) {
	links = links.filter(function(d) {
	    if(utils.checkExists(d.target.id, nodes, 'id') == true) {
		return d
	    }
	});
	nodes = nodes.filter(function(d) {
	    if(d.type == 'person') {
		if(utils.checkExists(d.id, links, 'source') == true) {
		    return d
		}
	    } else {
		return d
	    }
	});
	return {links:links, nodes:nodes}
    }

    function fixEvents(nodes) {
	nodes.filter(function(d) { return d.type == 'event'; }).forEach(function(e) {
	    e.fy = e.y;
	})
	return nodes;
    }
    
})();
